import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessengerService } from '../messenger/messenger.service';
import { EnvironmentService } from '../environment/environment.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeeplTranslationService {
  options;

  constructor(private http: HttpClient, private messengerService: MessengerService, private environmentService: EnvironmentService) {
    this.options = { headers: { 'authentication': this.messengerService.basicMessengerService.getAuthenticationHeader() } };
  }

  async translateHtml(content, targetLanguage, packageId) {
    return await this.http.post(environment.apiBaseURL + '/translation', { html: content, lang: targetLanguage, packageId: packageId }, this.options).toPromise();
  }

  async translate(content, targetLanguage, packageId?) {
    return await this.http.post(environment.apiBaseURL + '/translation', { text: content, lang: targetLanguage, packageId: packageId }, this.options).toPromise();
  }
}
